import { render } from "./SocialSignin.vue?vue&type=template&id=73448c38&scoped=true"
import script from "./SocialSignin.vue?vue&type=script&lang=ts"
export * from "./SocialSignin.vue?vue&type=script&lang=ts"

import "./SocialSignin.vue?vue&type=style&index=0&id=73448c38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73448c38"

export default script